import "react-perfect-scrollbar/dist/css/styles.css";
import React, { Suspense } from "react";
import { ThemeProvider } from "@material-ui/core";
import theme from "./theme";
import GlobalStyles from "./components/GlobalStyles";
import Router from "./routes/Router";
import i18n from "./i18n/i18n";
import { I18nextProvider } from "react-i18next";
import { AuthProvider } from "./context/auth/AuthContext";
import "./App.css";
import store from "./store/app.store";
import { Provider } from "react-redux";

const App = () => {
  return (
    <Suspense fallback="loading">
      <I18nextProvider i18n={i18n}>
        <ThemeProvider theme={theme}>
          <GlobalStyles />
          <AuthProvider>
            <Provider store={store}>
              <Router />
            </Provider>
          </AuthProvider>
        </ThemeProvider>
      </I18nextProvider>
    </Suspense>
  );
};

export default App;
